import axiosInstance from '../helpers/axiosConfig';

class ContactService {
  static createContact = (body) => axiosInstance.post('/contacts/create', body);
}

export default ContactService;
